@let isLoading = loadingIndicatorService.isLoading$(this) | async;

<div [formGroup]="form" [waiting]="isLoading">
  <icz-alert class="mb-16" severity="info" heading="Manuální vyvěšení bude provedeno k dnešnímu dni"></icz-alert>

  <div class="row">
    <icz-form-field
      class="grow"
      formControlName="name"
      label="Název"
    ></icz-form-field>
  </div>
  <div class="row">
    <icz-form-autocomplete
      class="grow"
      formControlName="officeDeskCategoryId"
      label="Kategorie úřední desky"
      [options]="officeDeskCategoryOptions"
    ></icz-form-autocomplete>
  </div>
  <div class="row">
    <icz-form-autocomplete
      class="grow"
      formControlName="officeDeskRegionId"
      label="Oblast úřední desky"
      [options]="officeDeskRegionOptions"
    ></icz-form-autocomplete>
  </div>
  @if (showUnpostFreeDayWarning()) {
    <icz-alert
      class="mb-8"
      severity="warning"
      heading="Datum svěšení připadá na den pracovního klidu, kdy nelze zásilku svěsit."
    ></icz-alert>
  }
  <div class="row">
    <icz-date-picker
      class="grow"
      formControlName="toPostFrom"
      [selectableDates]="presentOrFutureDateValidator"
      label="Vyvěsit od"
    ></icz-date-picker>
    <icz-form-field
      class="grow" type="integer"
      formControlName="postingDuration"
      label="Vyvěsit dní"
    ></icz-form-field>
    <icz-date-picker
      class="grow"
      formControlName="toPostTo"
      [selectableDates]="presentOrFutureDateValidator"
      [areHolidaysSelectable]="false"
      label="Vyvěsit do"
    ></icz-date-picker>
  </div>
  <div class="row">
    <icz-form-field
      class="grow"
      formControlName="originatorName"
      label="Původce jméno"
    ></icz-form-field>
    <icz-form-field
      class="grow"
      formControlName="originatorAddress"
      label="Původce adresa"
    ></icz-form-field>
  </div>
</div>

<icz-form-buttons>
  <icz-button leftButtons iczFormSubmit [disabled]="isLoading"
              (onAction)="manualPost()" primary label="Vyvěsit manuálně"></icz-button>
  <icz-button rightButtons [disabled]="isLoading"
              (onAction)="close()" label="Storno"></icz-button>
</icz-form-buttons>
